<template>
  <div>
    <b-table striped hover :items="items">
      <template #cell(o)="row">
        <i class="fa fa-arrow-up text-success"></i>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { code: 40, name: "6OZ", proyectado: 2.34, observado: 2.12, o: true },
        { code: 21, name: "6OZ", proyectado: 2.34, observado: 2.12, o: true },
        { code: 89, name: "1Pinta", proyectado: 2.34, observado: 2.12, o: true },
        { code: 38, name: "1Pinta", proyectado: 2.34, observado: 2.12, o: true }
      ]
    };
  }
};
</script>
